import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import "../App.scss";
import MultipleEntryPassCard from "../img/svg/multiple-entry-pass-card.svg";
import MultipleEntryPassCardOvdimBari from "../img/svg/multiple-entry-pass-card-ovdimbari.svg";
import MultipleEntryPassCardMaof from "../img/svg/multiple-entry-pass-card-maof.png";
import "../styles/multipleEntryPass.scss";
import "../styles/multipleEntryPassDetails.scss";
import { formatDate } from "../utils/dateUtils";
import { useSelector } from "react-redux";
import { isPartnerClalit, isPartnerMaoflaamit, selectPartner } from "../store/partnerStore";
import { isV2Enabled, V2_SCREEN_KEYS } from "../v2/registry";
import MultipleEntryPassDetailsV2 from "../v2/screens/multipleEntryPassDetails/MultipleEntryPassDetails";

const MultipleEntryPassDetails = () => {
  const { t } = useTranslation();
  const location = useLocation();

  const isClalit = useSelector(isPartnerClalit);
  const isMaofLaamit = useSelector(isPartnerMaoflaamit);
  const partner = useSelector(selectPartner);

  // Get the pass data from navigation state
  const pass = location.state?.pass;
  const isActive = pass?.IsAvailable;

  if (isV2Enabled(V2_SCREEN_KEYS.MULTIPLE_ENTRY_PASS_DETAILS, partner)) {
    return <MultipleEntryPassDetailsV2 pass={pass} />;
  }

  return (
    <div className="multiple-entry-pass-details">
      <div className="multiple-entry-pass-details__container">
        <img
          src={isClalit ? MultipleEntryPassCard : isMaofLaamit ? MultipleEntryPassCardMaof : MultipleEntryPassCardOvdimBari}
          className={isActive ? "" : "filter-grayscale"}
        />
        <div className="multiple-entry-pass-details__container__content">
          <div className="multiple-entry-pass-details__container__content__dates">
            <Typography className="multiple-entry-pass-details__container__description">
              <span className="multiple-entry-pass-details__container__label">
                {isActive ? t("EXPIRES_ON", { date: null }) : t("EXPIRED", { date: null })}
              </span>
              <span className="multiple-entry-pass-details__container__description">{formatDate(pass.EndDate)}</span>
            </Typography>
            <Typography className="multiple-entry-pass-details__container__description">
              <span className="multiple-entry-pass-details__container__label">
                {t("PURCHASE_MULTIPLE_ENTRY_PASS_DATE", {
                  date: null,
                })}
              </span>
              <span className="multiple-entry-pass-details__container__description">{formatDate(pass.StartDate)}</span>
            </Typography>
          </div>
          <div>
            <Typography className="multiple-entry-pass-details__container__description">
              <span className="multiple-entry-pass-details__container__label">
                {pass.isActive ? t("ENTRIES_REMAINING") : t("ENTRIES_USED")}
              </span>
              <span className="multiple-entry-pass-details__container__description">
                {t("ENTRIES_USED__COUNT", {
                  used: pass.NumberOfEntries,
                  total: pass.PossibleNumberOfEntries,
                })}
              </span>
            </Typography>
          </div>
        </div>
      </div>
      <div className="multiple-entry-pass-details__footer">
        {isActive && (
          <Typography>
            <span className="multiple-entry-pass-details__footer__help__title">{t("NEED_HELP")}</span>

            <span
              className="multiple-entry-pass-details__footer__help__description"
              onClick={() => window.open(`https://wa.me/972559458809`, "_blank")}
              style={{ cursor: "pointer" }}
            >
              {t("CHAT_WITH_US")}
            </span>
          </Typography>
        )}
      </div>
    </div>
  );
};

export default MultipleEntryPassDetails;
